import React from 'react';

/**
 * Wrapper điều hướng chung, không render Modal/Drawer.
 * Component con sẽ tự xử lý hiển thị (Modal, Drawer, logic).
 *
 * @param {string} mode - 'create' | 'edit' | 'detail'
 * @param {boolean} visible - hiển thị hay không
 * @param {object} currentItem - dữ liệu hiện tại
 * @param {function} onCancel - callback đóng popup
 * @param {function} loadData - callback reload dữ liệu
 * @param {boolean} isLoading - trạng thái loading
 * @param {JSX.Element} FormComponent - component form (tạo/sửa)
 * @param {JSX.Element} DetailComponent - component chi tiết
 */
const PopupWrapper = ({
    mode,
    visible,
    currentItem,
    onCancel,
    loadData,
    FormComponent,
    DetailComponent,
    detailLoading,
    ...rest
}) => {

    const isDetail = mode === 'detail';
    const isEdit = mode === 'edit';

    const ComponentToRender = isDetail ? DetailComponent : FormComponent;

    return (
        <ComponentToRender
            visible={visible}
            currentItem={isEdit || isDetail ? currentItem : null}
            onCancel={onCancel}
            loadData={loadData}
            detailLoading={detailLoading}
            isEdit={isEdit}
            {...rest}
        />
    );
};

export default PopupWrapper;
